var rossel = {};
rossel.jquery = jQuery.noConflict(true);

// for Boostrap, hammer, lazyload, sidebar, blueimpimage, boostrap-image-gallery, fixsvg, visible, cookiesdirective, ripple, owl.carousel, main
jQuery = rossel.jquery;
$ = rossel.jquery;

window.rossel = rossel;
